import { PanelRightOpen } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function DayViewPanelCollapsed({ setRightPanelOpen }) {
  return (
    <div className="flex h-full min-h-0 w-10 flex-none flex-col border-l border-border/80 bg-muted/20 shadow-[inset_1px_0_0_0_hsl(var(--border)/0.5)] md:sticky md:top-0 dark:bg-muted/20">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="group flex w-full flex-col items-center border-b border-border/60 bg-background/60 py-3.5 text-muted-foreground transition-colors hover:bg-muted/80 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset"
            aria-expanded={false}
            aria-controls="day-view-right-panel"
            onClick={() => setRightPanelOpen(true)}
          >
            <PanelRightOpen
              className="size-[18px] shrink-0 opacity-70 transition-opacity group-hover:opacity-100"
              strokeWidth={1.5}
              aria-hidden
            />
            <span className="sr-only">Show panel</span>
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="text-xs">
          Show panel
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
